import { render, staticRenderFns } from "./uusi-yek-poissaolo.vue?vue&type=template&id=7c46d862&scoped=true&"
import script from "./uusi-yek-poissaolo.vue?vue&type=script&lang=ts&"
export * from "./uusi-yek-poissaolo.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-yek-poissaolo.vue?vue&type=style&index=0&id=7c46d862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46d862",
  null
  
)

export default component.exports